/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common';
import '../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "offer": {
            "nested": {
              "models": {
                "nested": {
                  "BizConfiguration": {
                    "fields": {
                      "paymentPeriod": {
                        "type": ".squareup.capital.common.PaymentPeriod",
                        "id": 1,
                        "rule": "optional"
                      },
                      "paymentPeriodLength": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "paymentRatioInverse": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "repaymentMethod": {
                        "type": ".squareup.capital.offer.models.BizConfiguration.RepaymentMethod",
                        "id": 4,
                        "rule": "optional"
                      },
                      "interestRateBps": {
                        "type": "int32",
                        "id": 5,
                        "rule": "optional"
                      },
                      "numberPeriodsBeforeFirstPaymentPeriod": {
                        "type": "int32",
                        "id": 6,
                        "rule": "optional"
                      },
                      "estimatedRepaymentDays": {
                        "type": "int32",
                        "id": 7,
                        "rule": "optional"
                      },
                      "ficoPullStatus": {
                        "type": ".squareup.capital.offer.models.BizConfiguration.FicoPullStatus",
                        "id": 8,
                        "rule": "optional"
                      },
                      "ficoBoostMaxAmount": {
                        "type": ".squareup.common.Money",
                        "id": 9,
                        "rule": "optional"
                      },
                      "ficoUnboostedAmount": {
                        "type": ".squareup.common.Money",
                        "id": 10,
                        "rule": "optional"
                      },
                      "aprBps": {
                        "type": "int32",
                        "id": 11,
                        "rule": "optional"
                      },
                      "lineAmount": {
                        "type": ".squareup.common.Money",
                        "id": 12,
                        "rule": "optional"
                      },
                      "minPayBps": {
                        "type": "int32",
                        "id": 13,
                        "rule": "optional"
                      },
                      "plaidLinkStatus": {
                        "type": ".squareup.capital.offer.models.BizConfiguration.PlaidLinkStatus",
                        "id": 14,
                        "rule": "optional"
                      },
                      "maxBoostAmount": {
                        "type": ".squareup.common.Money",
                        "id": 15,
                        "rule": "optional"
                      },
                      "unboostedAmount": {
                        "type": ".squareup.common.Money",
                        "id": 16,
                        "rule": "optional"
                      },
                      "previousOfferSetToken": {
                        "type": "string",
                        "id": 17,
                        "rule": "optional"
                      },
                      "locUnderutilizationFeeAmount": {
                        "type": ".squareup.common.Money",
                        "id": 18,
                        "rule": "optional"
                      },
                      "locUnderutilizationMinDrawAmount": {
                        "type": ".squareup.common.Money",
                        "id": 19,
                        "rule": "optional"
                      },
                      "isPreview": {
                        "type": "bool",
                        "id": 20,
                        "rule": "optional"
                      },
                      "isImprovedOffer": {
                        "type": "bool",
                        "id": 21,
                        "rule": "optional"
                      },
                      "minPayPeriodUnit": {
                        "type": ".squareup.capital.common.PaymentPeriod",
                        "id": 22,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "RepaymentMethod": {
                        "values": {
                          "RM_DO_NOT_USE": 0,
                          "PORTION_OF_SALES": 1,
                          "FIXED_PAYMENTS": 2
                        }
                      },
                      "FicoPullStatus": {
                        "values": {
                          "FPS_DO_NOT_USE": 0,
                          "INELIGIBLE": 1,
                          "REQUIRED": 2,
                          "RECENT": 3,
                          "SKIPPED": 4,
                          "OPTED_OUT": 5
                        }
                      },
                      "PlaidLinkStatus": {
                        "values": {
                          "PLS_DO_NOT_USE": 0,
                          "INELIGIBLE_PLAID": 1,
                          "UNLINKED": 2,
                          "LINKED": 3,
                          "ERROR": 4,
                          "OPTED_OUT_PLAID": 5
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.offer?.nested?.models?.nested?.BizConfiguration && !$root.nested?.squareup?.nested?.capital?.nested?.offer?.nested?.models?.nested?.BizConfiguration?.nested?.RepaymentMethod && !$root.nested?.squareup?.nested?.capital?.nested?.offer?.nested?.models?.nested?.BizConfiguration?.nested?.FicoPullStatus && !$root.nested?.squareup?.nested?.capital?.nested?.offer?.nested?.models?.nested?.BizConfiguration?.nested?.PlaidLinkStatus) {
  $root.addJSON(jsonData);
}

/**
 * Captures params for BizLoan configuration. Will be extended as more
 * configurability options are rolled out.
 *
 * SOURCE BizConfiguration @ squareup/capital/offer/models.proto at 109:1
 */
export const BizConfiguration = $root.lookupType('squareup.capital.offer.models.BizConfiguration');
fixType(BizConfiguration);
Builder.createAndAttachToType(BizConfiguration);
/**
 * SOURCE RepaymentMethod @ squareup/capital/offer/models.proto at 110:3
 */
BizConfiguration.RepaymentMethod = $root.lookupEnum('squareup.capital.offer.models.BizConfiguration.RepaymentMethod').values;
/**
 * SOURCE FicoPullStatus @ squareup/capital/offer/models.proto at 116:3
 */
BizConfiguration.FicoPullStatus = $root.lookupEnum('squareup.capital.offer.models.BizConfiguration.FicoPullStatus').values;
/**
 * SOURCE PlaidLinkStatus @ squareup/capital/offer/models.proto at 136:3
 */
BizConfiguration.PlaidLinkStatus = $root.lookupEnum('squareup.capital.offer.models.BizConfiguration.PlaidLinkStatus').values;